// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"0dd51f8c","196":"eda1fcb3","229":"29b1bb1c","275":"83623242","411":"f8933a25","453":"5ffad5c6","544":"2543414f","784":"2dc5892a"}[chunkId] + ".chunk.js";
};